import react, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridValueGetterParams, getGridStringOperators, } from "@mui/x-data-grid";
import { Dialog, DialogActions, DialogContent, DialogTitle, Select, MenuItem, InputLabel, FormControl, Paper } from "@mui/material";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import styled from "styled-components";
import todayCalanerImage from "../../icons/todaysCalander.svg"
import Drawer from "../../components/common/drawer/drawer";
import { Typography, Button, Checkbox, Fab, IconButton, InputAdornment, TextField, Stack, Box } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Add, Save, SaveAlt, Search } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import OrderLineItemModal from "../../components/modals/orderLineItemModal";
import clearFilterImage from "../../icons/clearFilter.svg"
import searchIcon from "../../icons/searchIcon.svg"
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import PartyList from "../../components/modals/partyListModal";
import AddRoutePlan from "../../components/modals/addRoutePlan";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import TodayRoutePlanModal from "../../components/modals/TodayRoutePlanModal";
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile && ` position: relative; `} `;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;
const TableContainer = styled.div`
// height: calc(
//   100vh - ${isMobile ? "56px - 20px - 82.23px" : "112px - 34px - 43.77px"}
// );
  width: 100%;
  // border: solid 1px lightGrey;
  border-radius: 8px;
`;
const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};
  ${isMobile &&
  `
    flex-direction: column;
  `}
`;

export default function RoutePlanManagement() {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [loading, setLoading] = useState(false);
  const [accessChanges, setAccessChanges] = useState("");
  const [showWarehouseFormModal, setShowWarehouseFormModal] = useState();
  const [modal, setModal] = useState(false)
  const [modalData, setModalData] = useState()
  const [addModal, setAddModal] = useState(false)
  const [rowCount, setRowCount] = useState()
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20, });
  const [newOrderStatus, setNewOrderStatus] = useState(0);
  const [filter, setFilter] = useState(false)
  const [searchTerm, setSearchTerm] = useState(null)
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
      const [accessModulesData, setAccessModulesData] = useState([]);
  const [dateRange1, setDateRange1] = useState(false)
  const [startDate1, setStartDate1] = useState()
  const [endDate1, setEndDate1] = useState()
  const [minDate, setMinDate] = useState()
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [callApi, setCallApi] = useState(false);
  const [search, setSearch] = useState("")
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [selectedSeries, setSelectedSeries] = useState("")
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [openDialog, setOpenDialog] = useState(false);
  const [reason, setReason] = useState("");
  const [rejectData, setRejectData] = useState(null);
  const [editMode, setEditMode] = useState(false)
  const [editModalData, setEditModalData] = useState({})
  const [partyList, setPartyList] = useState([]);
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [todayRoutePlanModalOpen, setTodayRoutePlanModalOpen] = useState(false);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const formatDateTime = (inputDateString) => {
    const inputDate = new Date(inputDateString);
    if (isNaN(inputDate.getTime())) {
      return 'Invalid Date';
    }
    const year = inputDate.getUTCFullYear();
    const month = String(inputDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(inputDate.getUTCDate()).padStart(2, '0');
    const hours = String(inputDate.getUTCHours()).padStart(2, '0');
    const minutes = String(inputDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(inputDate.getUTCSeconds()).padStart(2, '0');
    const formattedDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDateString;
  }
   const [sessions, setSessions] = useState([]); // from API
      const [selectedSession, setSelectedSession] = useState("");
      const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
      const [isSessionDisabled, setIsSessionDisabled] = useState(false);
  
       useEffect(() => {
          fetchSessions();
        }, []);
      
        const fetchSessions = async () => {
          try {
            setLoading(true);
            const response = await window.Platform.database.getAllSessions();
            if (response?.data) {
              setSessions(response.data);
            }
          } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
          } finally {
            setLoading(false);
          }
        };
  
          useEffect(() => {
            if (!startDate && !endDate) {
              setIsSessionDisabled(false);
            }
          }, [startDate, endDate]);
        

  useEffect(() => {
    setCallApi(true);
    if (callApi) {
      fetchOrder()
    }
  }, [paginationModel.page, newOrderStatus, paginationModel.pageSize]);

  // useEffect(() => {
  //   if (filter) {
  //     onFilterChange(searchTerm)
  //   }
  // }, [paginationModel.page]);

  const fetchOrder = async () => {
    try {
      setLoading(true);
      let data = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        status: newOrderStatus,
        // ownerName: search,
        startDate: startDate,
        endDate: endDate,
        // ownerId: rm,
        ownerName: rm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
      }
      let results = await window.Platform.database.getRoutePlan(data);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
      setRowCount(results.data1)
      setAccessChanges(jsonArrayWithId);
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
    }
    finally {
      setLoading(false)
    }
  }

  const onFilterChange = async (filterModel) => {
    try {
      setLoading(true);
      setFilter(true)
      if (filterModel) {
        const response = await window.Platform.database.filterRoutePlan({ filterField: filterModel.field, filterValue: filterModel.value, pageNumber: paginationModel.page, startDate: startDate, endDate: endDate })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setAccessChanges(jsonArrayWithId)
        setRowCount(response.data1)
      }
      else {
        const response = await window.Platform.database.filterRoutePlan({ filterField: "date", pageNumber: paginationModel.page, startDate: startDate, endDate: endDate })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setAccessChanges(jsonArrayWithId)
        setRowCount(response.data1)
      }
      setLoading(false);
    }
    catch (err) {
      console.error(err)
      setLoading(false);
      window.NotificationUtils.showError("Error While Recieving Data Please Wait and try again");
    }
  };

  // useEffect(() => {
  //   // getClusterInPicklist()
  //   if (userData?.role.toLowerCase().includes('admin')) {
  //     getAllUsers()
  //   }
  //   if (userData?.role == 'rsm') {
  //     getUsers('rsm', userData?.id)
  //   }
  //   if (userData?.role == 'asm') {
  //     getUsers('asm', userData?.id)
  //   }
  // }, [])

  useEffect(() => {
    fetchAccessModules();
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers();
    }
    if (userData?.role === 'rsm') {
      getUsers('rsm', userData?.id);
    }
    if (userData?.role === 'asm') {
      getUsers('asm', userData?.id);
    }

    // Set tomorrow as default date
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const formatted = tomorrow.toISOString().split("T")[0];
    setStartDate(formatted);
    setEndDate(formatted);
  }, []);

         const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId : userData?.id,
                moduleId : "wzxRdAWFxJ"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }

  //   useEffect(() => {
  //   if (startDate && endDate && !callApi) {
  //     fetchOrder();
  //   }
  // }, [startDate, endDate]);


  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
      return;
    }
    else {
      setAllUsers(results?.data)
      setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
      setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
      setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
      setLoading(false);
    }
  }

  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }

  }

  const getEmployeeColumns = () => {
    const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));

    let result = [
      {
        field: "name",
        headerName: "RM Name",
        sortable: false,
        width: 190,
        filterOperators: stringOperators,
        editable: false,
        valueGetter: (params) => {
          return (params.row?.name.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(" ") || "N/A");
        },
        renderCell: (params) => {
          let name = params.row?.name.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(" ") || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "taggedUserName",
        headerName: "Tagged Colleague",
        sortable: false,
        width: 180,
        filterOperators: stringOperators,
        editable: false,
        valueGetter: (params) => {
          return (params.row?.taggedUserName || "N/A");
        },
        renderCell: (params) => {
          let name = params.row?.taggedUserName || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "date",
        headerName: "Route Date",
        width: 110, filterable: false,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.date ? formatToOnlyDate(params.row?.date) : "N/A");
        },
        renderCell: (params) => {
          let name = params.row?.date && formatToOnlyDate(params.row?.date) || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "createdAt",
        headerName: "Created At",
        width: 170,
        sortable: false,
        filterable: false,
        valueGetter: (params) => {
          return (params.row?.createdAt ? formatTimeStamp(params.row?.createdAt) : "N/A");
        },
        renderCell: (params) => {
          let name = formatTimeStamp(params.row.createdAt) || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "approvalStatus",
        headerName: "Status",
        width: 100, filterable: false,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.status === 0 ? "Pending" : params.row?.status === 1 ? "Approved" : params.row?.status === 1 ? "Rejected" : "Partially Approved" || "N/A");
        },
        renderCell: (params) => {
          let name = params.row?.status === 0 ? "Pending" : params.row?.status === 1 ? "Approved" : params.row?.status === 1 ? "Rejected" : "Partially Approved" || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "approvedBy",
        headerName: "Action taken By",
        width: 150, filterable: false,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.actionBy?.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(" ") || "N/A");
        },
        renderCell: (params) => {
          let name = params.row?.actionBy?.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(" ") || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Approve Order",
        headerName: "Actions",
        width: 130, filterable: false,
        sortable: false,
        disableExport: true,
        renderCell: (params) => {
          let value = params.row?.routeId
          let value1 = formatToOnlyDate(params.row?.date)
          let ownerId = params.row?.ownerId
          return (
            <Stack direction={"row"} spacing={0}>
              <Tooltip title="Click to view party in route-plan"><IconButton variant="extended" color="primary" onClick={(e) => {
                e.stopPropagation();
                getRouteplanById(value, value1, ownerId);
                // viewRoutePlanModal(params.row?.routeId);
              }} >
                <RemoveRedEyeIcon />
              </IconButton></Tooltip>
           {accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no"&&    <Tooltip title="Click to approve route-plan"><IconButton disabled={params.row?.status === 1 || params.row?.status === 2} variant="extended" sx={{ color: "#008000" }} onClick={(e) => {
                e.stopPropagation();
                approveRejectOrder({ id: value, approvalStatus: "1" });
              }} >
                <ThumbUpIcon />
              </IconButton></Tooltip>}
              {/* <Tooltip title="Click to reject route-plan"><IconButton disabled={params.row?.status === 1 || params.row?.status === 2} variant="extended" sx={{ color: "red" }}
                // onClick={(e) => {
                //   e.stopPropagation();
                //   approveRejectOrder({ id: value, approvalStatus: "2" });
                // }} 
                onClick={(e) => { e.stopPropagation(); handleReject({ id: value }); }}>
                <ThumbDownIcon />
              </IconButton></Tooltip> */}
              {accessModulesData && accessModulesData[0]?.is_update?.toLowerCase() != "no"&& <Tooltip title="Click to edit route-plan"><IconButton variant="extended" onClick={(e) => { editData(params.row); }}>
                <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "400" }} />
              </IconButton></Tooltip>}
            </Stack>
          )
        },
      },

    ];
    return result
  }

  const editData = async (data) => {
    setEditModalData(data)
    setEditMode(true)
    // setAddModal(true)
    try {
      let results = await window.Platform.database.getRouteplanById({ id: data?.routeId });

      if (results.status == false) {
        const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setPartyList(jsonArrayWithId)
      }
      else {
        console.log("results=======", results);
        window.NotificationUtils.showError("Something Went Wrong!")
      }
    }
    catch (error) {
      console.log(error)
      window.NotificationUtils.showError("Something Went Wrong!")
    }
  }

  const handleReject = (data) => {
    setRejectData(data);
    setOpenDialog(true);
  };

  const handleConfirmReject = () => {
    if (reason.trim() === "") {
      window.NotificationUtils.showError("Remark is required to reject the order.")
      return;
    }
    approveRejectOrder({ ...rejectData, approvalStatus: "2", reason });
    setOpenDialog(false);
    setReason("");
    setRejectData(null);
  };

  const approveRejectOrder = async (val) => {
    try {
      let message = val.approvalStatus == "1" ? "Route plan approved successfully" : "Route plan rejected successfully";
      setLoading(true);
      let payload = {
        id: val?.id,
        approvalStatus: val?.approvalStatus,
        isDirectApproval: true,
        reason: val?.reason
      }
      // console.log(val, "valllllllllll", payload,"paylaodaddddddddddddddd");
      // return;
      const results = await window.Platform.database.approvePartialRouteNotification(payload)
      if (results.status) {
        window.NotificationUtils.showError(results.message);
        setLoading(false)
        return;
      }
      window.NotificationUtils.showSuccess(message);
      setLoading(false)
      fetchOrder()
    }
    catch (err) {
      console.log(err)
      window.NotificationUtils.showError("Something Went Wrong!")
      setLoading(false)
    }
  }

  const formatTimeStamp = (timestampFromDB) => {
    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,  // Use 12-hour clock
    };
    const formattedDate = new Date(timestampFromDB).toLocaleString('en-US', options);

    return formattedDate;
  };

  const formatToOnlyDate = (val) => {
    const concertDate = new Date(val);
    const year = concertDate.getFullYear();
    const month = concertDate.getMonth() + 1; // Months are zero-indexed, so we add 1
    const day = concertDate.getDate();
    const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
    return formattedDate;
  }

  const viewRoutePlanModal = async (val) => {
    setModalData(val);
    setModal(true);
  }

  const getRouteplanById = async (val, val1, ownerId) => {
    try {
      setLoading(true)
      setModalData()
      let sentData = { id: val }
      let results = await window.Platform.database.getRouteplanById(sentData);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));

      setModalData({ data: jsonArrayWithId, id: val, date: val1, ownerId: ownerId })
      setModal(true)
      setLoading(false)
    }
    catch (error) {
      console.log(error)
      window.NotificationUtils.showError("Something Went Wrong!")
      setLoading(false)
    }
  }

  function CustomToolbar() {
    return (
      <div>
        <GridToolbarContainer>
          <Button
            onClick={() => setNewOrderStatus("")}
            style={{ backgroundColor: newOrderStatus === "" ? "#8787f470" : "white", color: newOrderStatus === "" ? "#000000" : "black", fontWeight: "500", }}>
            All
          </Button>
          <Button
            onClick={() => setNewOrderStatus(0)}
            style={{ backgroundColor: newOrderStatus === 0 ? "#fe9f13" : "white", color: newOrderStatus === 0 ? "white" : "black", fontWeight: "500", }}>
            Pending
          </Button>
          <Button
            onClick={() => setNewOrderStatus(1)}
            style={{ backgroundColor: newOrderStatus === 1 ? "green" : "white", color: newOrderStatus === 1 ? "white" : "black", fontWeight: "500", }}>
            Approved
          </Button>
          <Button
            onClick={() => setNewOrderStatus(2)}
            style={{ backgroundColor: newOrderStatus === 2 ? "red" : "white", color: newOrderStatus === 2 ? "white" : "black", fontWeight: "500", }}>
            Rejected
          </Button>
          <Button
            onClick={() => setNewOrderStatus(3)}
            style={{ backgroundColor: newOrderStatus === 3 ? "#cddc39" : "white", color: newOrderStatus === 3 ? "black" : "black", fontWeight: "500", }}>
            Partially Approved
          </Button>
          <Typography variant="body1" className="ml-4" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
          <Select
            value={paginationModel.pageSize}
            variant="outlined"
            size="small"
            onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
            // sx={{ width: 90, fontSize: 14 }}
            sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}
          >
            {[10, 20, 30, 50, 100].map((role) => (
              <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role}</MenuItem>
            ))}
          </Select>
        </GridToolbarContainer>


      </div>
    );
  }

  const renderContent = () => {
    return (
      <DataGridContainer style={{ height: !accessChanges?.length ? '200px' : 'auto' }}>
        <DataGrid
          className="payrollGrid"
          density="compact"
          rows={accessChanges}
          columns={getEmployeeColumns()}
          sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
          disableSelectionOnClick
          disableRowSelectionOnClick
          disableDensitySelector
          rowHeight={60}
          pageSizeOptions={[10]}
          onFilterModelChange={(val) => {
            if (val?.items[0]?.value?.length > 0) {
              onFilterChange(val.items[0])
              setSearchTerm(val.items[0])
            }
            else if (!val.items[0]?.value && startDate && endDate) {
              setSearchTerm(null)
              onFilterChange()
              console.log("CHECKING...1")
            }
            else {
              fetchOrder()
              setSearchTerm(null)
              setFilter(false)
            }
          }
          }
          filterMode="server"
          rowCount={rowCount}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          components={{
            Toolbar: CustomToolbar,
          }}
        />
      </DataGridContainer>
    );
  };

  const exportroutes = async () => {
    setLoading(true);
    try {
      let data = {
        startDate: startDate,
        endDate: endDate,
        status: newOrderStatus,
        ownerName: rm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
      }
      let result = await window.Platform.database.exportData("routeplan/downloadRouteplanExcel",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `RouteReport_${formattedDate}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }

  const clearFilters = async () => {
    setLoading(true);
    setFilter(false)
    // setSearch("")
    setStartDate("")
    setEndDate("")
    setNewOrderStatus(0)
    setRm("")
    setRsm("")
    setAsm("")
       setIsDateRangeDisabled(false);
    setIsSessionDisabled(false);
    setSelectedSession("");
    setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
    setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
    setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
    setPaginationModel((prev) => ({ ...prev, pageSize: 20 }))
    setAccessChanges([]);
    setRowCount(0);
      const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const formatted = tomorrow.toISOString().split("T")[0];
    setStartDate(formatted);
    setEndDate(formatted);
    setLoading(false);
    // try {
    //   let data1 = {
    //     pageNumber: paginationModel.page,
    //     ownerName: "",
    //     status: 0
    //   }
    //   let results = await window.Platform.database.getRoutePlan(data1);
    //   const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
    //   setRowCount(results?.data1)
    //   setAccessChanges(jsonArrayWithId);
    // } catch (error) {
    //   console.error(error);
    //   window.NotificationUtils.showError("Error Fetching Data");
    //   setLoading(false);
    // }
    // finally {
    //   setLoading(false)
    // }
  }

  return (
    <>
      {loading && <OpaqueLoading />}
      <StaffEditorPageContainer>
        <HeaderContainer>
          <Box sx={{ mt: 1, width: "100%" }}>

            <Paper elevation={3}
              sx={{
                p: 2,
                mb: 2,
                width: '100%',        // takes full width of parent
                // maxWidth: '1000px',   // optional: control max width
                mx: 'auto',
                backgroundColor: "#ebf0fa"          // center it horizontally
              }}>
              <div className="container-fluid">
                <div className="row mb-2 align-items-end">
                  {userData?.role.includes('admin') && <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                      <Select label="Select HO" value={rsm} variant="outlined" size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>All</MenuItem>
                        {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{role.name} - {role.username}</MenuItem>))}
                      </Select>
                    </FormControl>
                  </div>}
                  {userData?.role != 'asm' && <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                      <Select label="Select ARM" value={asm} variant="outlined" size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>All</MenuItem>
                        {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{role.name} - {role.username}</MenuItem>))}
                      </Select>
                    </FormControl>
                  </div>}
                  <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM:</InputLabel>
                      <Select label="Select RM" value={rm} variant="outlined" size="small" onChange={(e) => { setRm(e.target.value); }} sx={{ width: '100%', fontSize: 14 }}>
                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>All</MenuItem>
                        {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{role.name} - {role.username}</MenuItem>))}
                      </Select>
                    </FormControl>
                  </div>
                 {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no"&&  <div className="col-md-3 mt-2">
                    <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '13px', borderRadius: '10px' }} onClick={() => exportroutes()}>
                      Download
                    </Button>
                  </div>}
                </div>
                <div className="row align-items-center mt-2">
                  <div className="col-md-3 mt-2">
                    <FormControl fullWidth size="small">
                      <TextField label="From Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }} value={startDate} onChange={(e) => setStartDate(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                          style: { color: "black", fontSize: "14px", fontWeight: 500 }
                        }}
                        inputProps={{
                          style: { color: "black", fontSize: "14px", fontWeight: 500 }
                        }} />
                    </FormControl>
                  </div>
                  <div className="col-md-3 mt-2">
                    <FormControl fullWidth size="small">
                      <TextField label="To Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }} value={endDate} onChange={(e) => setEndDate(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                          style: { color: "black", fontSize: "14px", fontWeight: 500 }
                        }}
                        inputProps={{
                          style: { color: "black", fontSize: "14px", fontWeight: 500 }
                        }} />
                    </FormControl>
                  </div>
                  <div className="col-md-3 mt-2">
                    <Button variant="contained" color="primary" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { setCallApi(true); fetchOrder() }}>
                      Find
                    </Button>
                  </div>
                  <div className="col-md-3 mt-2">
                    <Button variant="contained" color="secondary" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '13px', borderRadius: '10px' }} onClick={() => clearFilters()}>
                      Clear Filters
                    </Button>
                  </div>

                </div>
                <div className="row mt-2">
                   <div className="col-md-3">
                                                        <FormControl fullWidth size="small">
                                                          <InputLabel
                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                          >
                                                            Select Session
                                                          </InputLabel>
                                                          <Select
                                                            label="Select Session"
                                                            value={selectedSession}
                                                            disabled={isSessionDisabled}
                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                            onChange={(e) => {
                                                              const selected = sessions.find((item) => item.id === e.target.value);
                                                              setSelectedSession(e.target.value);
                                    
                                                              if (selected) {
                                                                // ✅ Convert UTC → IST (local date)
                                                                const start = new Date(selected.startDate);
                                                                const end = new Date(selected.endDate);
                                    
                                                                const startIST = new Date(start.getTime() + (5.5 * 60 * 60 * 1000))
                                                                  .toISOString()
                                                                  .split("T")[0];
                                                                const endIST = new Date(end.getTime() + (5.5 * 60 * 60 * 1000))
                                                                  .toISOString()
                                                                  .split("T")[0];
                                    
                                                                setStartDate(startIST);
                                                                setEndDate(endIST);
                                    
                                                                // ✅ Disable manual date range if session chosen
                                                                setIsDateRangeDisabled(true);
                                                              } else {
                                                                // ✅ If cleared, re-enable date inputs
                                                                setIsDateRangeDisabled(false);
                                                              }
                                                            }}
                                    
                                                          >
                                                            <MenuItem value="">
                                                              <em>Select Session</em>
                                                            </MenuItem>
                                                            {sessions.map((s) => (
                                                              <MenuItem key={s.id} value={s.id}>
                                                                {s.sessionName}
                                                              </MenuItem>
                                                            ))}
                                                          </Select>
                                                        </FormControl>
                                                      </div>
                  <div className="col-md-4">
                    <Button fullWidth startIcon={<img src={todayCalanerImage} alt="Today's Calendar" height={21} width={21} />} sx={{
                      fontSize: '14px',
                      borderRadius: '10px',
                      size: 'small',
                      fullWidth: true,
                      backgroundColor: '#c99b00',
                      color: 'white',
                      '&:hover': {
                        backgroundColor: '#706130',
                      }
                    }}
                      onClick={() => setTodayRoutePlanModalOpen(true)}>
                      Today's Route Plan
                    </Button>
                  </div>
                </div>
              </div>
            </Paper>
            <Box display="flex" justifyContent="flex-end" gap={2}>

            {accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no"&&   <div className="col-md-3 text-end">
                <Button variant="contained" color="primary" fullWidth onClick={() => setAddModal(true)} sx={{ borderRadius: '10px' }}> <Add sx={{ mr: 1 }} /> Add New  </Button>
              </div>}
            </Box>
          </Box>
        </HeaderContainer>
        <TableContainer>{renderContent()}</TableContainer>
      </StaffEditorPageContainer>
      {
        modal && <PartyList
          onCancel={() => { setModal(false); fetchOrder(); }}
          loading={loading}
          data={modalData}
          routeId={modalData?.id}
          routeDate={modalData?.date}
          ownerId={modalData?.ownerId}
          getRouteplanById={getRouteplanById} />
      }
      {
        addModal && <AddRoutePlan onClose={() => setAddModal(false)} fetchData={() => fetchOrder()} routeDate={modalData?.date} />
      }

      {
        editMode && <AddRoutePlan onClose={() => setEditMode(false)} fetchData={() => fetchOrder()} editMode={editMode} editModalData={editModalData} partyList={partyList} />
      }

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>Reject Route Plan</DialogTitle>
        <DialogContent>
          <TextField autoFocus margin="dense" label="Remark" type="text" fullWidth variant="outlined" value={reason} onChange={(e) => setReason(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmReject} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {todayRoutePlanModalOpen && (
        <TodayRoutePlanModal
        is_download = {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no"? true : false}
          onClose={() => setTodayRoutePlanModalOpen(false)}
        />
      )}
    </>
  );
}
